//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/Assemblies.js";
import "../no/CAM.js";
import "../no/AttributePropertiesBuilder.js";
import "../no/AttributeTemplatesBuilder.js";
import "../no/FeatureGeneralPropertiesBuilder.js";
import "../no/MassPropertiesBuilder.js";
import "../no/ObjectGeneralPropertiesBuilder.js";
import "../no/PreviewPropertiesBuilder.js";
import "../no/BasePart.js";
let d=[[],[[["objects"],"CreateAttributePropertiesBuilder",{R_:{builder:"AttributePropertiesBuilder"}},1,1],[["objects"],"CreateMassPropertiesBuilder",{R_:{builder:"MassPropertiesBuilder"}},1,0],[["objects"],"CreatePreviewPropertiesBuilder",{R_:{builder:"PreviewPropertiesBuilder"}},1,0],[["objects"],"CreateGeneralCAMPropertiesBuilder",{R_:{builder:"CAM.GeneralPropertiesBuilder"}},1,0],[["objects"],"CreateAssembliesParameterPropertiesBuilder",{R_:{builder:"Assemblies.AssembliesParameterPropertiesBuilder"}},1,0],[["objects"],"CreateFeatureGeneralPropertiesBuilder",{R_:{builder:"FeatureGeneralPropertiesBuilder"}},1,0],[["objects"],"CreateObjectGeneralPropertiesBuilder",{R_:{builder:"ObjectGeneralPropertiesBuilder"}},1,0],[["objects"],"CreateAssembliesGeneralPropertiesBuilder",{R_:{builder:"Assemblies.AssembliesGeneralPropertiesBuilder"}},1,0],[[],"CreateAttributeTemplatesBuilder",{R_:{builder:"AttributeTemplatesBuilder"}},0,0]],[["MassCollection","Gateway.MassCollection",0]]];
SPLM.PropertiesManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.PropertiesManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;